var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsEnum, IsString } from "class-validator";
export var ResolveEndpointType;
(function (ResolveEndpointType) {
    ResolveEndpointType["EPIC"] = "epic";
})(ResolveEndpointType || (ResolveEndpointType = {}));
export class ResolveEndpointInput {
}
__decorate([
    IsEnum(ResolveEndpointType)
], ResolveEndpointInput.prototype, "type", void 0);
__decorate([
    IsString()
], ResolveEndpointInput.prototype, "brandId", void 0);
__decorate([
    IsString()
], ResolveEndpointInput.prototype, "portalId", void 0);
__decorate([
    IsString()
], ResolveEndpointInput.prototype, "endpointId", void 0);
export class ResolveFastenEpicEndpointDto {
    constructor() {
        this.type = ResolveEndpointType.EPIC;
    }
}
__decorate([
    IsEnum(ResolveEndpointType)
], ResolveFastenEpicEndpointDto.prototype, "type", void 0);
__decorate([
    IsString()
], ResolveFastenEpicEndpointDto.prototype, "epicEndpointId", void 0);
__decorate([
    IsString()
], ResolveFastenEpicEndpointDto.prototype, "epicFhirUrl", void 0);
__decorate([
    IsString()
], ResolveFastenEpicEndpointDto.prototype, "epicBrandIdentifier", void 0);
